if (!customElements.get('product-sku')) {
  class ProductSku extends HTMLElement {
    constructor() {
      super();

      this.handleUpdateRef = this.handleUpdate.bind(this);
    }

    handleUpdate(event) {
      if (!event.detail.sku) return;

      this.innerHTML = this.getAttribute('data-text').replace(
        '{{ sku }}',
        event.detail.sku,
      );
    }

    disconnectedCallback() {
      document.removeEventListener('sku:update', this.handleUpdateRef);
    }

    connectedCallback() {
      document.addEventListener('sku:update', this.handleUpdateRef);
    }
  }

  customElements.define('product-sku', ProductSku);
}
